export default "__VITE_PUBLIC_ASSET__df60dd8f__"